/**
 * Human Layer — My Vision fixture.
 *
 * Mirrors `humanLayerVoice.ts`'s discipline exactly: `status: 'not_configured'`
 * and an empty statement list, because nobody has saved anything yet — the
 * same "knowing who somebody is isn't the same as them having set this up"
 * reasoning Profile's and Voice's seeds give. No category is pre-filled with
 * illustrative text, even where a real, sourced answer exists (Partnership
 * Net's own Vision and Mission strings are LOCKED in the messaging canon) —
 * seeding a fixture that represents "nobody has configured this yet" with
 * real content would misrepresent that state, exactly the fabrication
 * `buildHumanLayerManifest`'s own docblock warns against. That real text
 * belongs in the tab's own reference copy, not in what `getVisionProfile`
 * returns before anyone has saved anything.
 *
 * `getVisionProfile` always returns this seed; `updateVisionProfile`
 * (staticAdapter.ts) builds a fresh object over it rather than writing back,
 * so a page reload restores the seed exactly — same pattern as
 * `humanLayerVoice.ts`.
 */

import type { HumanLayerVisionProfile } from '../../contracts';
import { DEMO_USER_ID } from './humanLayerProfile';

/** Fixed, because nothing here persists — mirrors `HUMAN_LAYER_VOICE_VERSION`. */
export const HUMAN_LAYER_VISION_VERSION = 'fixture-1';

export const HUMAN_LAYER_VISION_SEED: HumanLayerVisionProfile = {
  id: 'human-layer-vision-session-user',
  owner: { scope: 'individual', userId: DEMO_USER_ID },
  status: 'not_configured',
  statements: [],
  audit: {
    createdBy: DEMO_USER_ID,
    createdAt: '2026-01-05',
    updatedBy: DEMO_USER_ID,
    updatedAt: '2026-01-05',
    version: HUMAN_LAYER_VISION_VERSION,
  },
};
